export const CUSTOMER_AREA_BENEFIT_ORIGIN = 'ECOMMERCE_AREA_CLIENTE';
